// Helpers for editing the dates of a saved multi-date event.
// Registrations keep a reference to their date by label (and a copy of the date),
// so a saved date can be moved and its registrations stay on it.

const toTime = (date) => (date ? new Date(date).getTime() : NaN);

export const isSameMoment = (a, b) => !!a && !!b && toTime(a) === toTime(b);

// Saved dates (they have an `originalDate`) whose date/time was changed in the form.
export const getMovedSavedDates = (values) => {
  if (!values?.multiDateEvent) return [];
  const rows = [
    { label: values?.dateLabel, date: values?.date, originalDate: values?.originalDate, originalLabel: values?.originalDateLabel },
    ...(values?.additionalEventDates || []),
  ];
  return rows
    .filter((row) => row?.originalDate && row?.date && !isSameMoment(row.date, row.originalDate))
    .map((row) => ({
      label: row.label || row.originalLabel || '',
      originalLabel: row.originalLabel || '',
      from: row.originalDate,
      to: row.date,
    }));
};

// Does this participant have a registration on the (saved) date?
export const isRegisteredOnDate = (participant, { originalLabel, from }) =>
  (participant?.eventsDates || []).some(
    (d) =>
      (originalLabel && (d?.label === originalLabel || d?.name === originalLabel)) ||
      isSameMoment(d?.date, from)
  );

// The event's current date for one of a participant's registered dates; registrations store
// a copy of the date when they were made, so it is looked up on the event by label.
export const getCurrentRegisteredDate = (dateEntry, eventDates) => {
  const match = (eventDates || []).find(
    (d) => d?.label && (d.label === dateEntry?.label || d.label === dateEntry?.name)
  );
  return match?.eventDate || dateEntry?.date;
};
